<template>
  <div>
    <div class="b-banner-con">
      <v-header></v-header>
      <v-nav></v-nav>
    </div>
    <v-breadcrumb></v-breadcrumb>
    <div class="b-center-container">
      <div class="b-container">
        <div class="b-center-main">
          <div class="b-richtext">
            <p v-html="richText2"></p>
          </div>
        </div>
      </div>
    </div>
    <v-contact></v-contact>
  </div>
</template>
<script>
/* eslint-disable */
import Header from "@/components/header/";
import Nav from "@/components/nav/";
import Copy from "@/components/copy/"
import Breadcrumb from "@/components/breadcrumb/"
import Contact from "@/components/contact/";
export default {
  data () {
    return {
      richText2: '',
    };
  },
  mounted () {
    this.richText2 = '<p style="text-align: left; "><span style="font-size: 22px; border-bottom: solid 3px #033d80;">生物标记物与新药研发平台</span></p>'
      + '<p>&nbsp;</p>'

      + '<div id="left" style="float:left ; width:65%; height:100%;">'
      + '<p style="margin-right : 20px;text-align: justify;line-height: 300%"><span style="margin-left: 36px; font-size: 16px">平台目前拥有元素分析仪、离子色谱仪、电感耦合等离子发射光谱仪、电感耦合等离子质谱仪、红外光谱仪、拉曼光谱仪、核磁共振波谱仪、液相色谱 - 质谱仪、气相色谱 - 质谱仪、单晶 X 射线衍射仪、热重分析仪、反应量热仪、全自动平行反应器、在线红外、聚焦光束反射测量仪、颗粒录影显微镜等80余台仪器，能够提供临床组学研究、药物分析、药物质量控制、 药物分离纯化以及合成工艺安全性评价等服务。</span></p>'
      + '</div>'

      + '<div id="right" style="float:left ; width:35%; height:100%;">'
      + '<p style="margin-left : 120px"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/lizhang.jpg" style="float: left; width: 180px; margin-right: 170px; margin-top:20px;" border="0" vspace="0" alt=""></p>'
      + '<p style="margin-left: 130px;text-align: justify"><span style="font-size: 16px;"><b>负责人：张莉</b></span></p>'
      + '</div>'

      + '<div>'
      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;临床组学分析系统&nbsp;&nbsp;&nbsp; </span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：高通量基因测序仪、色谱质谱仪、核磁共振波谱仪、ICP-MS等。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：蛋白组学、非靶向和靶向代谢/脂质组学、基因测序检测技术。</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;&nbsp;抗体药物分析系统 &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：液相-高分辨质谱仪、蛋白质相互作用仪、酶标仪、核磁共振波谱仪等。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：各类生物药的结构表征、杂质分析以及生物药的活性检测。</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px; color: white;"> &nbsp;&nbsp;&nbsp;质量控制分析系统 &nbsp;&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：光谱、核磁、色谱质谱、EA、ICP-MS、XRD、电镜、差热、热重等。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：各类药物的结构确证，杂质分析、药物质量控制及辅料包材分析等。</span></p>'

      + '<p><span style="font-size: 16px;border:10px solid #033d80; background-color: #033d80; border-radius: 7px;color: white; "> &nbsp;&nbsp;工艺安全性评价与分离纯化系统&nbsp;&nbsp;</span></p>'
      + '<p style="margin-top : 30px;margin-bottom : 10px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">关键设备：全自动反应量热器、绝热加速量热仪、颗粒录影显微镜、制备色谱等。</span></p>'
      + '<p style="margin-top : 0px;margin-bottom : 30px; margin-right : 20px;text-align: justify"><span style="font-size: 16px">支撑服务：合成工艺安全性评价、在线监测药物结晶过程、化合物分离纯化等。</span></p>'

      + '<p style="text-align: center;"><img src="https://nbcloud-repairorder-image.oss-cn-beijing.aliyuncs.com/biomarker_Drug_en_1.jpg" style="float: left; width: 800px; " border="0" vspace="0" ></p>'

      + '<p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p><p>&nbsp;</p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; border-bottom: solid 3px #033d80;">联系人</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">张莉</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Email: lizhang09@sjtu.edu.cn</span></p>'
      + '<p style="text-align: left; "><span style="font-size: 16px; ">Tel: 021 - 34208498 - 6421</span></p>'

      + '</div>'

      + '<p>&nbsp;</p><p>&nbsp;</p>'
},
  components: {
    "v-header": Header,
    "v-nav": Nav,
    "v-copy": Copy,
    "v-breadcrumb": Breadcrumb,
    "v-contact": Contact,
  }
};
</script>
<style lang="scss">
  @media screen and (max-width:600px) {
	.b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
	    width: 1440px;
	}
  }

  @media screen and (min-width:960px) {
    .b-banner-con{
	    //padding: 22px 0;
	    background: url(../../assets/img/banner_bg.png) no-repeat!important;
	    background-size: cover!important;
	    .b-header{
	      margin-bottom: 0px;
	    }
	    height: 134px;
    }
  }
.b-richtext {
  text-align:left;
  b,
  strong {
    font-weight: 700;
  }
  p {
    margin: 0 0 10px;
    line-height: 24px;
  }
  line-height: 24px;
}
</style>



// WEBPACK FOOTER //
// src/pages/Service14/index.vue